import { useEffect, useState } from 'react';

export function ServiceProgressRail({ label, sections }) {
  const [activeId, setActiveId] = useState(sections[0]?.id);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;

    const nodes = sections
      .map(({ id }) => document.getElementById(id))
      .filter(Boolean);

    const observer = new IntersectionObserver((entries) => {
      const visibleEntry = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top))[0];

      if (visibleEntry) setActiveId(visibleEntry.target.id);
    }, {
      rootMargin: `-${Math.max(132, window.innerHeight * 0.22)}px 0px -58% 0px`,
      threshold: 0,
    });

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, [sections]);

  const activeIndex = Math.max(0, sections.findIndex(({ id }) => id === activeId));
  const progress = sections.length > 1 ? (activeIndex / (sections.length - 1)) * 100 : 100;

  return (
    <nav className="service-progress" aria-label={`${label} page sections`}>
      <div className="service-progress__inner section-shell">
        <span className="service-progress__label">On this page</span>
        <ol>
          {sections.map(({ id, shortLabel }) => (
            <li key={id}>
              <a
                href={`#${id}`}
                aria-current={id === activeId ? 'location' : undefined}
                onClick={() => setActiveId(id)}
              >
                {shortLabel}
              </a>
            </li>
          ))}
        </ol>
        <span className="service-progress__count" aria-hidden="true">
          {String(activeIndex + 1).padStart(2, '0')} / {String(sections.length).padStart(2, '0')}
        </span>
        <span className="service-progress__meter" aria-hidden="true">
          <span style={{ '--service-progress': `${progress}%` }} />
        </span>
      </div>
    </nav>
  );
}
